import React from 'react'
import { makeStyles } from '@material-ui/core'
import TestsPanel from './TestsPanel'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden'
  },
  tabBar: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 var(--padding-md)',
    borderBottom: '1px solid var(--color-neutral-200)',
    backgroundColor: 'var(--color-neutral-050)',
    flexShrink: 0
  },
  tab: {
    padding: 'var(--padding-sm) var(--padding-md)',
    fontSize: 'var(--text-size-sm)',
    fontWeight: 600,
    color: 'var(--color-primary-700)',
    borderBottom: '2px solid var(--color-primary-500)'
  },
  content: {
    flex: 1,
    minHeight: 0,
    overflow: 'hidden'
  }
}))

function WorkSurface () {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.tabBar} role='tablist'>
        <div role='tab' aria-selected className={classes.tab}>
          Tests
        </div>
      </div>
      <div className={classes.content}>
        <TestsPanel />
      </div>
    </div>
  )
}

export default WorkSurface
